import { useAuth } from '@/features/auth';
import { Navbar } from '@/shared/components/Navigation/Dashboard/Navbar/Navbar';
import { getNavSections } from '@/shared/components/Navigation/Dashboard/Sidebar/getNavSections';
import { Sidebar } from '@/shared/components/Navigation/Dashboard/Sidebar/Sidebar';
import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

const SIDEBAR_COLLAPSED_KEY = 'sidebar-collapsed';
const LG_BREAKPOINT = 1024;

export default function DashboardLayout() {
  const { user } = useAuth();

  // Mobile sidebar starts closed, will be toggled by hamburger
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= LG_BREAKPOINT);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    return stored === 'true';
  });

  // Handle window resize - close mobile sidebar when resizing
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= LG_BREAKPOINT) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(sidebarCollapsed));
  }, [sidebarCollapsed]);

  const handleToggleCollapse = () => {
    setSidebarCollapsed(prev => !prev);
  };

  const handleCloseSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, [setSidebarOpen]);

  if (!user) return null;

  const sections = getNavSections();

  return (
    <div className='min-h-screen bg-gray-50'>
      <Sidebar
        isOpen={sidebarOpen}
        isCollapsed={sidebarCollapsed}
        sections={sections}
        onToggleCollapse={handleToggleCollapse}
        onClose={handleCloseSidebar}
      />

      {/* Main content */}
      <div
        className={clsx(
          'min-h-screen transition-all duration-300',
          sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-62.5'
        )}
      >
        {/* Header */}
        <Navbar setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />
        {/* Page content */}
        <main className='p-6'>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
